import 'dom4'
import 'svgxuse'
import domready from 'domready'
import LoadingScreen from '../loading-screen'
import Logo from '../logo'
import AgeVerification from '../age-verification'
import GlobalHeader from '../global-header'
import NabookiReviews from '../section/nabooki-reviews'
import HomeProducts from '../section/home-products'
import AudioToggle from '../audio-toggle'
import HomeHero from '../section/home-hero'
import ProductReviewsSlider from '../woocommerce/single-product/single-product-reviews'
import VisitUs from '../section/visit-us-blocks'
import GlobalFooter from '../global-footer'

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

domready(() => {

  if (touchDevice) {
    document.body.classList.add('touch')
  }

  history.scrollRestoration = "manual"

  window.onLoad = function () {
    window.scrollTo(0,0);
  };

  window.addEventListener('load', e => {
    document.body.classList.add('site-loaded')
    if (document.body.classList.contains('home')) {
      document.body.classList.add('play-home-animation')
    }
  })

  // const cookieExists = Cookies.get('allowed_entry_live')

  // if (cookieExists) {
  //   if (document.body.classList.contains('home')) {
  //     document.body.classList.add('play-home-animation')
  //   }
  // }

  document.queryAll('[data-component="loading-screen"]').forEach(element => {
    new LoadingScreen({
      element
    })
  })

  document.queryAll('[data-component="logo"]').forEach(element => {
    new Logo({
      element
    })
  })

  // document.queryAll('[data-component="age-verification"]').forEach(element => {
  //   new AgeVerification({
  //     element
  //   })
  // })

  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element
    })
  })

  document.queryAll('[data-component="visit-us-block"]').forEach(element => {
    new VisitUs({
      element
    })
  })

  document.queryAll('[data-component="nabooki-reviews"]').forEach(element => {
    new NabookiReviews({
      element
    })
  })

  document.queryAll('[data-component="home-products"]').forEach(element => {
    new HomeProducts({
      element
    })
  })

  document.queryAll('[data-component="home-hero"]').forEach(element => {
    new HomeHero({
      element
    })
  })

  document.queryAll('[data-component="audio-toggle"]').forEach(element => {
    new AudioToggle({
      element
    })
  })

  document.queryAll('[data-component="product-reviews-slider"]').forEach(element => {
    new ProductReviewsSlider({
      element
    })
  })

  document.queryAll('[data-component="global-footer"]').forEach(element => {
    new GlobalFooter({
      element
    })
  })

})



// WEBPACK FOOTER //
// ./components/app/index.js